<template src="./template.html"></template>

<script>
    /* eslint-disable */
    import { mapGetters } from 'vuex';
    import { CREATE_USER, FETCH_SUPPLIERS, FETCH_USERS, UPDATE_USER } from '../../../store/types';
    import responseFormat from '../../../util/responseFormat';

    export default {
        name: 'Settings',
        computed: {
            ...mapGetters(['get_suppliers', 'get_supplier', 'get_users', 'get_user', 'get_current_user', 'user_is_admin', 'get_roles', 'get_role_id', 'get_role_by_id']),
        },
        data () {
            const validatePass = (rule, value, callback) => {
                if (this.formAction === 'create' || value !== '') {
                    if (value === '') {
                        callback(new Error('Passwort wird benötigt'));
                    } else if (value && value.length < 4) {
                        callback(new Error('Password muss 4 Zeichen lang sein'));
                    } else {
                        if (this.user.password !== '') {
                            this.$refs.user.validateField('repeat_password');
                        }
                    }
                }
                callback();
            };
            const validatePass2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('Bitte Passwort wieder eingeben'));
                } else if (value !== this.user.password) {
                    callback(new Error('Die beiden Eingaben stimmen nicht überein!'));
                } else {
                    callback();
                }
            };
            const validateSupplier = (rule, value, callback) => {
                if (this.user.role_id) {
                    const selectedUserRole = this.get_role_by_id(this.user.role_id);

                    if (selectedUserRole.name !== 'admin') {
                        if (value === '') {
                            callback(new Error('Supplier wird benötigt'));
                        }
                    } else {
                        this.user.supplier_id = null;
                    }
                }

                callback();
            };
            return {
                user: {},
                formTitle: 'Bearbeiten',
                loading: false,
                rules: {
                    role_id: [
                        { required: true, message: 'Rolle wird benötigt', trigger: 'blur' },
                    ],
                    supplier_id: [
                        { required: true, validator: validateSupplier, trigger: 'blur' },
                    ],
                    name: [
                        { required: true, message: 'Name wird benötigt', trigger: 'change' },
                    ],
                    email: [
                        { required: true, message: 'E-mail wird benötigt', trigger: 'change' },
                    ],
                    password: [
                        { required: true, validator: validatePass, trigger: 'blur' },
                    ],
                    repeat_password: [
                        { required: true, validator: validatePass2, trigger: 'change' }
                    ],
                },
            };
        },
        props: {
          formAction: {
            default: 'edit',
            required: false,
            type: String,
          },
          userId: {
            type: Number
          },
        },
        created () {
          this.prepareEditForm();
        },
        methods: {
            prepareEditForm () {
              this.user = this.get_current_user;
            },
            submitForm (formAction) {
              this.$refs[formAction].validate((valid) => {
                  if (valid) {
                      this.loading = true;
                      // EDIT
                      this.$store.dispatch(UPDATE_USER, this.user).then((resp) => {
                          this.$message.success(resp.message);
                          // this.$emit('close');
                      }).catch((resp) => {
                          this.$message.error(responseFormat.getErrorMessage(resp));
                      }).then(() => {
                          this.loading = false;
                      });
                  }
              });
            },
        },
    };
</script>



// WEBPACK FOOTER //
// src/components/pages/settings/Settings.vue